import defaultRiskIcon from './risk_indicator_default.svg';
import AbnormalGeolocationIcon from './abnormal_geolocation.svg';
import AnonymousIpIcon from './anonymous_ip.svg';
import apiIcon from './silverfort_api.svg';
import asRepRoastingIcon from './as_rep_roasting.svg';
import authenticationSpikeIcon from './authentication_spike.svg';
import azureIcon from './azure.svg';
import azureShadowAdminIcon from './azure_shadow_admin.svg';
import entraIDSyncedAdminIcon from './entra_id_synced_admin.svg';
import BadChecksumIcon from './bad_checksum.svg';
import bruteForceIcon from './brute_force.svg';
import BuiltInAdminIcon from './built_in_admin.svg';
import BuiltInGuestIcon from './built_in_guest.svg';
import CertifriedIcon from './certifried.svg';
import lightCertificateAuthIcon from './light_certificate_auth.svg';
import darkCertificateAuthIcon from './dark_certificate_auth.svg';
import passwordAuthIcon from './password_auth.svg';
import CredentialScanningIcon from './credential_scanning.svg';
import customInsightIcon from './custom_insights.svg';
import deniedMFAIcon from './denied_mfa.svg';
import domainAdminIcon from './domain_admin.svg';
import DomainControllerIcon from './domain_controller.svg';
import externalNotificationsIcon from './external_notification.svg';
import geoLocationAnomalyIcon from './geo_location_anomaly.svg';
import highRiskAuthsIcon from './risk_auths.svg';
import highRiskResourceIcon from './high_risk_resource.svg';
import HistoricEncryptionIcon from './malicious_historic_encryption_type.svg';
import impossibleTravelIcon from './impossible_travel.svg';
import interactiveLoginIcon from './interactive_login.svg';
import KerberoastingIcon from './kerberoasting.svg';
import leakedCredintialsIcon from './leaked_credentials.svg';
import lockedAccountIcon from './locked_accounts.svg';
import lockedAfterChangeIcon from './locked_after_change.svg';
import Log4ShellIcon from './log4shell.svg';
import maliciousIPIcon from './malicious_ip.svg';
import mfaBombingIcon from './mfa_bombing.svg';
import newAccountIcon from './new_account.svg';
import NewCreatedServerIcon from './new_created_server.svg';
import NtlmIcon from './ntlm.svg';
import oldOSIcon from './old_os.svg';
import oldPasswordIcon from './old_password.svg';
import ticketFromNewIpIcon from './ticket_from_new_ip.svg';
import passTheHashIcon from './pass_the_hash.svg';
import passwordNeverExpiresIcon from './password_never_expires.svg';
import PayloadInjectionIcon from './payload_injection.svg';
import privilegedUserIcon from './privileged_user.svg';
import privilegedUserNotInProtectedUsersGroupIcon from './privileged_user_not_in_protected_users_group.svg';
import reconnaissanceIcon from './reconnaissance.svg';
import RepetitiveBehaviorIcon from './repetitive_behavior.svg';
import RiskAuthIcon from './risky_auth.svg';
import RiskyDCIcon from './risky_domain_controller.svg';
import RiskyResourceIcon from './risky_resource.svg';
import serviceAccountIcon from './service_accounts.svg';
import serviceAccountInteractiveLoginIcon from './service_account_interactive_login.svg';
import shadowAdminIcon from './shadow_admin.svg';
import sharedDeviceIcon from './shared_device.svg';
import sharedUserIcon from './shared_user.svg';
import smbEnumerationIcon from './smb_enumeration.svg';
import staleResourceIcon from './stale_resource.svg';
import staleUserIcon from './stale_user.svg';
import staleDomainController from './stale_domain_controller.svg';
import domainControllerOldPassword from './domain_controller_old_password.svg';
import mixedSessionHostIcon from './mixed_session_host.svg';
import SuspiciousAuthIcon from './suspicious_auth.svg';
import threatIntelligenceIcon from './threat_intelligence.svg';
import UacFlagIcon from './uac_flag.svg';
import unconstrainedDelegationIcon from './unconstrained_delegation.svg';
import unfamiliarSignInIcon from './unfamiliar_sign_in.svg';
import UserHackIcon from './user_hack.svg';
import UserRetrospectiveIcon from './user_retrospective.svg';
import userRiskIcon from './user_risk.svg';
import userWithSpnIcon from './user_with_spn.svg';
import weakEncryptionIcon from './weak_encryption.svg';
import lightAdminWithSpnIcon from './light_admin_with_spn.svg';
import lightAsRepRoastingIcon from './light_as_rep_roasting.svg';
import lightAzureShadowAdminIcon from './light_azure_shadow_admin.svg';
import lightBadChecksumIcon from './light_bad_checksum.svg';
import lightCertifriedIcon from './light_certifried.svg';
import lightCustomInsightIcon from './light_custom_insights.svg';
import lightDomainAdminIcon from './light_domain_admin.svg';
import lightInteractiveLoginIcon from './light_interactive_login.svg';
import lightKerberoastingIcon from './light_kerberoasting.svg';
import lightLockedAccountIcon from './light_locked_accounts.svg';
import lightLockedAfterChangeIcon from './light_locked_after_change.svg';
import lightLog4ShellIcon from './light_log4shell.svg';
import lightOldOSIcon from './light_old_os.svg';
import lightOldPasswordIcon from './light_old_password.svg';
import lightPasswordNeverExpiresIcon from './light_password_never_expires.svg';
import lightPrivilegedUserIcon from './light_privileged_user.svg';
import lightServiceAccountIcon from './light_service_accounts.svg';
import lightShadowAdminIcon from './light_shadow_admin.svg';
import lightSharedDeviceIcon from './light_shared_device.svg';
import lightSharedUserIcon from './light_shared_user.svg';
import lightSmbEnumerationIcon from './light_smb_enumeration.svg';
import lightStaleResourceIcon from './light_stale_resource.svg';
import lightStaleUserIcon from './light_stale_user.svg';
import lightUnconstrainedDelegationIcon from './light_unconstrained_delegation.svg';
import lightWeakEncryptionIcon from './light_weak_encryption.svg';
import printNightmareFixBrightIcon from './print_nightmare_fix_bright.svg';
import printNightmareFixDarkIcon from './print_nightmare_fix_dark.svg';
import sapphireTicketIcon from './sapphire_ticket.svg';
import unmatchedTicketIcon from './unmatched_ticket.svg';
import unprivilegedCertificateTemplateModifierIcon from './certificate_template_modifier.svg';
import unprivilegedDnsAdminLight from './unprivileged_dns_admin_light.svg';
import unprivilegedDnsAdminDark from './unprivileged_dns_admin_dark.svg';
import userPasswordExposedIcon from './user_password_exposed.svg';

import adminWithSpnIcon from './admin_with_spn.svg';
import accountRevokedIcon from './account_revoked.svg';
import authntication_spike from './authntication_spike.svg';
import badRealmIcon from './bad_realm.svg';
import expiredPasswordIcon from './expired_password.svg';
import expiredTicketIcon from './expired_ticket.svg';
import newDeviceIcon from './new_device.svg';
import sharedEntityIcon from './shared_entity.svg';

// stealthyAdminsIcon uses the same file as shadowAdminIcon
const stealthyAdminsIcon = shadowAdminIcon;

export const Icons = {
    AbnormalGeolocationIcon,
    AnonymousIpIcon,
    apiIcon,
    asRepRoastingIcon,
    authenticationSpikeIcon,
    authntication_spike,
    azureIcon,
    azureShadowAdminIcon,
    entraIDSyncedAdminIcon,
    BadChecksumIcon,
    bruteForceIcon,
    BuiltInAdminIcon,
    BuiltInGuestIcon,
    CertifriedIcon,
    lightCertificateAuthIcon,
    darkCertificateAuthIcon,
    passwordAuthIcon,
    CredentialScanningIcon,
    customInsightIcon,
    deniedMFAIcon,
    domainAdminIcon,
    DomainControllerIcon,
    externalNotificationsIcon,
    geoLocationAnomalyIcon,
    highRiskAuthsIcon,
    highRiskResourceIcon,
    HistoricEncryptionIcon,
    impossibleTravelIcon,
    interactiveLoginIcon,
    KerberoastingIcon,
    leakedCredintialsIcon,
    lockedAccountIcon,
    lockedAfterChangeIcon,
    Log4ShellIcon,
    maliciousIPIcon,
    mfaBombingIcon,
    newAccountIcon,
    NewCreatedServerIcon,
    NtlmIcon,
    oldOSIcon,
    oldPasswordIcon,
    ticketFromNewIpIcon,
    passTheHashIcon,
    passwordNeverExpiresIcon,
    PayloadInjectionIcon,
    privilegedUserIcon,
    privilegedUserNotInProtectedUsersGroupIcon,
    reconnaissanceIcon,
    RepetitiveBehaviorIcon,
    RiskAuthIcon,
    RiskyDCIcon,
    RiskyResourceIcon,
    serviceAccountIcon,
    serviceAccountInteractiveLoginIcon,
    shadowAdminIcon,
    sharedDeviceIcon,
    sharedUserIcon,
    sharedEntityIcon,
    smbEnumerationIcon,
    staleResourceIcon,
    staleUserIcon,
    staleDomainController,
    domainControllerOldPassword,
    stealthyAdminsIcon,
    mixedSessionHostIcon,
    SuspiciousAuthIcon,
    threatIntelligenceIcon,
    UacFlagIcon,
    unconstrainedDelegationIcon,
    unfamiliarSignInIcon,
    UserHackIcon,
    UserRetrospectiveIcon,
    userRiskIcon,
    userPasswordExposedIcon,
    userWithSpnIcon,
    weakEncryptionIcon,
    defaultRiskIcon,
    lightAdminWithSpnIcon,
    lightAsRepRoastingIcon,
    lightAzureShadowAdminIcon,
    lightBadChecksumIcon,
    lightCertifriedIcon,
    lightCustomInsightIcon,
    lightDomainAdminIcon,
    lightInteractiveLoginIcon,
    lightKerberoastingIcon,
    lightLockedAccountIcon,
    lightLockedAfterChangeIcon,
    lightLog4ShellIcon,
    lightOldOSIcon,
    lightOldPasswordIcon,
    lightPasswordNeverExpiresIcon,
    lightPrivilegedUserIcon,
    lightServiceAccountIcon,
    lightShadowAdminIcon,
    lightSharedDeviceIcon,
    lightSharedUserIcon,
    lightSmbEnumerationIcon,
    lightStaleResourceIcon,
    lightStaleUserIcon,
    lightUnconstrainedDelegationIcon,
    lightWeakEncryptionIcon,
    printNightmareFixBrightIcon,
    printNightmareFixDarkIcon,
    sapphireTicketIcon,
    unmatchedTicketIcon,
    unprivilegedCertificateTemplateModifierIcon,
    unprivilegedDnsAdminLight,
    unprivilegedDnsAdminDark,
    adminWithSpnIcon,
    accountRevokedIcon,
    badRealmIcon,
    expiredPasswordIcon,
    expiredTicketIcon,
    newDeviceIcon
};
